class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.emptySearchResults = this.querySelector('#empty-predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    const closeButton = this.querySelector('.js-search-close-btn')

    closeButton?.addEventListener('click', () => {
      this.input.value = '';
      this.predictiveSearchResults.innerHTML = this.emptySearchResults.innerHTML;
      this.predictiveSearchResults.classList.remove('predictive-search-scroll');
    })
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    this.predictiveSearchResults.classList.remove('predictive-search-scroll');
    if (!searchTerm.length) {
      this.close();
      return;
    }
    
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;

        // Get the innerHTML of the element
        const divResults = new DOMParser().parseFromString(text, 'text/html').querySelector("#predictive-search-results");
        // Check if the content is empty
        if (divResults.hasChildNodes()) {
          this.predictiveSearchResults.classList.add('predictive-search-scroll');
        }
       
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
